export default __webpack_public_path__ + "static/media/crow@3x.d6e9c168.png";